import React from 'react'

const styles = {
  footer: {
    borderTop: '1px solid #ddd',
    padding: '24px 0',
    marginTop: '48px',
    textAlign: 'center',
    color: 'var(--color-muted)',
    fontSize: '0.875rem',
  },
}

export default function Footer() {
  return (
    <footer style={styles.footer} className="no-print">
      <p>Create and share crossword puzzles</p>
    </footer>
  )
}
